import { use, useEffect, useRef } from "react";

import { getConfig } from "lib/get-config";
import { NavigationContext } from "lib/navigation/use-navigation";

const PERCENTAGES = [5, 10, 30, 60];

function pushToDataLayer(event: Record<string, unknown>) {
  const w = window as unknown as { dataLayer?: Record<string, unknown>[] };
  w.dataLayer ??= [];
  w.dataLayer.push(event);
}

export function useFullBookAnalytics() {
  const { art, trials } = getConfig();
  const { page, totalPages } = use(NavigationContext)!;

  const isFullBook = trials !== 1;

  const stateRef = useRef({
    checkpoints: [] as number[],
    totalPages: 0,
  });

  useEffect(() => {
    if (isFullBook && totalPages > 0) {
      const state = stateRef.current;

      if (state.totalPages !== totalPages) {
        state.totalPages = totalPages;
        state.checkpoints = PERCENTAGES.map(p =>
          Math.ceil((p / 100) * totalPages)
        );
      }

      let index = state.checkpoints.indexOf(page);
      if (index === -1) {
        index = state.checkpoints.indexOf(page - 1);
      }
      if (index !== -1) {
        const percent = PERCENTAGES[index];
        state.checkpoints[index] = -1;
        pushToDataLayer({
          event: `percentage_of_read_full_${percent}`,
          book_id: art,
          art_type: "text",
        });
      }
    }
  }, [isFullBook, page, totalPages, art]);
}
